

export class LicenseToDriveDataInput implements ILicenseToDriveDataInput {
    /** The auto-generated id of the license to drive master */
    licenseToDriveId!: number;

    constructor(data?: ILicenseToDriveDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseToDriveId = _data["licenseToDriveId"];
        }
    }

    static fromJS(data: any): LicenseToDriveDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseToDriveId"] = this.licenseToDriveId;
        return data; 
    }
}

export interface ILicenseToDriveDataInput {
    /** The auto-generated id of the license to drive master */
    licenseToDriveId: number;
}

